import { render, staticRenderFns } from "./Cooperative.vue?vue&type=template&id=3ccfee6a&scoped=true&"
import script from "./Cooperative.vue?vue&type=script&lang=js&"
export * from "./Cooperative.vue?vue&type=script&lang=js&"
import style0 from "./Cooperative.vue?vue&type=style&index=0&id=3ccfee6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfee6a",
  null
  
)

export default component.exports